/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-24 09:11:27
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-10-21 13:22:32
 * @FilePath: \hlweb2.0\src\language\en.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const home = {
  banner1: "Shanghai Huilian Office Equipment Co., Ltd.",
  banner2: "The office service expert beside you",
  anchorPoint1: "Introduction to Huilian",
  anchorPoint1Con: {
    detail: "",
    title: "Company Profile",
    content: {
      title: "About HuiLian Office",
      list: [
        "Shanghai Huilian Office Equipment Co., Ltd. was established in 1999. It is a professional solution provider focused on improving corporate office efficiency and controlling office costs, with a solid engineering technology foundation and high standard of service.",
        "The company is a technology-based small and medium-sized enterprise, a national high-tech enterprise, a specialized and innovative enterprise, and a key service industry enterprise. It has independently developed multiple sets of office information management software (with more than 50 software copyright registrations obtained).",
        "The company is engaged in the full lifecycle management of office assets, document digitization, office intelligence, smart office spaces, and on-site office services.",
      ],
    },
    footList: [
      {
        top: "20 years+",
        con: "Industry experience",
      },
      { top: "1000+", con: "Corporate clients" },
    ],
  },
  anchorPoint2: "Development History",
  anchorPoint2Con: {
    detail:
      "For more than twenty years, we have always adhered to a dual focus on innovation and high-quality service, continuously breaking through ourselves, pursuing excellence, and growing together with our customers.",
    imgUrl: require("../assets/images/home/developzh.png").default,
  },
  anchorPoint3: "Corporate Culture",
  anchorPoint3Con: {
    detail:
      "Our cultural values are the cornerstone of the company's development, guiding our behaviors and decision-making principles, and shaping a unique corporate culture.",
    contentList: [
      {
        tit: "Customer first",
        con: "Always centered around customer needs, dedicated to providing you with exceptional service and experience beyond expectations.",
      },
      {
        tit: "Profession-oriented",
        con: "Upholding the spirit of craftsmanship, with profound technical accumulation and rigorous standards, we deliver trustworthy products and services.",
      },
      {
        tit: "Continuous innovation",
        con: "Actively embrace changes in technology and concepts, and continuously innovate to create long-term value and competitive advantage for you.",
      },
      {
        tit: "Win-win cooperation",
        con: "Regard customers as partners walking side by side, striving to achieve mutual growth and value sharing in every collaboration.",
      },
    ],
    footList: [
      {
        tit: "Mission",
        con: "Provide enterprises with efficient, energy-saving, and intelligent office cost control solutions to help clients achieve cost reduction and efficiency improvement.",
      },
      {
        tit: "Vision",
        con: "Become a leader in the digital transformation solutions for the office industry",
      },
      {
        tit: "Values",
        con: "Establish a foundation with integrity and collaboration, break boundaries with innovative thinking, fulfill commitments through efficient execution, and achieve a win-win future with customers.",
      },
    ],
  },
  anchorPoint4: "Products and Services",
  anchorPoint4Con: {
    titleColor: "Huilian",
    title1: "What can ",
    title2:" do for you?",
    detail:
      "We provide comprehensive digital solutions to assist enterprises in achieving digital transformation and enhancing their core competitiveness. Whether it is standardized products or customized services, we can meet your needs.",
  },
  anchorPoint5: "Cultural Activities",
};
export const productList = [
  {
    title: "Archival Digitization Services",
    imgUrl: require("../assets/images/productList1.png").default,
    con1: "Huilian Archive Integrated Intelligent Service Platform",
    con2: "Digital archives management",
    con3: "Efficient, intelligent, and secure file management solutions",
    con3List:["Efficient, intelligent, and secure file management solutions"],
    jump: "Learn more",
    jumpLine: "/solution/archives",
    linked: "Try it now",
  },
  {
    title: "Archival Information Technology Products",
    imgUrl: require("../assets/images/productList2.png").default,
    con1: "Huilian Intelligent Archive One File One Enjoy®",
    con2: "Intelligent Archive Information Management Platform",
    con3: "Achieve full-process digital management of archives for 'establishing, collecting, storing, managing, using, and disposing', allowing archive data to come alive, be utilized, and be enjoyed.",
    con3List:["Implement the archive processes of 'establish, receive, store, manage, use, and dispose'","Full-process digital management","Bring archive data to life, make use of it, and enjoy it"],
    jump: "Learn more",
    jumpLine: "/solution/infoServices",
    linked: "Try it now",
  },
  {
    title: "Asset lifecycle management",
    imgUrl: require("../assets/images/productList3.png").default,
    con1: "Huilian One-stop Asset Full Lifecycle Management",
    con2: "Intelligent Office Asset Management Platform",
    con3: `From acquisition to disposal, the "full lifecycle digital management" of assets ensures that every asset is utilized to its fullest potential and provides maximum value.`,
    con3List:["From acquisition to disposal, the asset's 'full lifecycle digital management'","Make every asset used to its fullest an"],
    jump: "Learn more",
    jumpLine: "/solution/asset",
    linked: "Try it now",
  },
  {
    title: "Smart digital management of space operations",
    imgUrl: require("../assets/images/productList4.png").default,
    con1: "Huilian Smart Space Operation Management Platform",
    con2: "Smart digital management of space operations",
    con3: "Create a smooth, trustworthy, and warm smart space experience.",
    con3List:["Create a smooth, trustworthy, and warm smart space experience"],
    jump: "Learn more",
    jumpLine: "/solution/spaceOperations",
    linked: "Try it now",
  },
  {
    title: "On-site service",
    imgUrl: require("../assets/images/productList5.png").default,
    con1: "Huilian professional IT talent solutions",
    con2: "On-site service platform",
    con3: "Provide comprehensive IT talent services for enterprises to assist in their digital transformation.",
    con3List:["Providing comprehensive IT talent services for enterprises","Empowering enterprises in digital transformation"],
    jump: "Learn more",
    jumpLine: "/solution/residency",
    linked: "Get a dedicated IT residency solution",
    linked2: "Learn about our team",
  },
];
export const navigation = {
  home: "Website Homepage",
  product: "Product service",
  product1: "Archival Digitization Services",
  product2: "Archival Information Technology Products",
  product3: "Asset lifecycle management",
  product4: "Smart digital management of space operations",
  product5: "On-site service",
  success: "Successful case",
  about: "Contact Us",
  experience: "Try it now",
  experience_con:
    "Now start trying simpler and more efficient ways of working.",
  footer1: "Shanghai Huilian",
  footer2: "Website Homepage",
  footer5Con: ["Contact Us", "Visit us"],
  footer6: "Try it now",
  footer6Con1: [
    { til: "Service Hotline", con: "021-57186429" },
    { til: "Contact email", con: "huilian118@163.com" },
  ],
  footer6Con2: {
    til: "Follow us",
    con1: "WeCom",
    con2: "Huilian official account",
  },
};
const solution_archives = {
  archives1: {
    til: "Problems and challenges faced by archival work",
    imgUrl: require("../assets/images/solution/archives/customized.png")
      .default,
    contentLeftList: [
      {
        title: "Search dilemma",
        conList: [
          "Physical file storage + manual management method",
          "Unable to cope with the need for high-speed retrieval of targets.",
        ],
      },
      {
        title: "Missing Standards",
        conList: [
          "Missing relevant filing norms and standards",
          "I don't know what data to collect.",
          "Who does these things?",
        ],
      },
      {
        title: "Talent shortage",
        conList: [
          "There is a scarcity of full-time archival management talent.",
          "There is a greater shortage of comprehensive talents in information technology, business, and archives.",
        ],
      },
    ],
    contentRightList: [
      {
        title: "Information silo",
        conList: [
          "Low level of informatization",
          "Low utilization rate of archival data",
        ],
      },
      {
        title: "Archiving Challenges",
        conList: [
          "Era of information explosion",
          "How to clean and filter the data needed for archiving",
          "To facilitate the establishment of independent knowledge management in enterprises.",
        ],
      },
      {
        title: "Safety hazard",
        conList: [
          "Address risks such as security and technological obsolescence.",
          "Ensure that electronic files are trustworthy and accessible in the long term.",
        ],
      },
    ],
  },
  archives2: {
    til: "Digital transformation of the archival industry",
    detail:
      "Achieving advanced integrated management of physical archives, electronic archives, and data archives.",
    contentList: [
      {
        tit: "Physical file",
        imgUrl: require("../assets/images/solution/archives/industry1.png")
          .default,
        icon1:
          require("../assets/images/solution/archives/industry_icon1_1.png")
            .default,
        icon2:
          require("../assets/images/solution/archives/industry_icon1_2.png")
            .default,
        detail:
          "Digital processing of traditional paper documents, contracts, files, drawings, and other physical archives.",
        list: [
          "Entity Collection",
          "Data Indexing",
          "Hierarchical Storage",
          "Image Retrieval",
        ],
      },
      {
        tit: "Electronic file",
        imgUrl: require("../assets/images/solution/archives/industry2.png")
          .default,
        icon1:
          require("../assets/images/solution/archives/industry_icon2_1.png")
            .default,
        icon2:
          require("../assets/images/solution/archives/industry_icon2_2.png")
            .default,
        detail:
          "There is already standardized management of electronic documents, including format conversion, metadata addition, and classification organization.",
        list: [
          "Format standardization",
          "Long-term availability",
          "Orderly control",
          "Knowledge empowerment",
        ],
      },
      {
        tit: "Data Archive",
        imgUrl: require("../assets/images/solution/archives/industry3.png")
          .default,
        icon1:
          require("../assets/images/solution/archives/industry_icon3_1.png")
            .default,
        icon2:
          require("../assets/images/solution/archives/industry_icon3_2.png")
            .default,
        detail:
          "The integrated management of structured data, including the archiving of databases, tables, and business system data.",
        list: [
          "Massive aggregation",
          "Deep sorting",
          "Trusted evidence storage",
          "Decision support",
        ],
      },
    ],
  },
  archives3: {
    til: "Internal and external synergy · Intelligent and efficient · Achieving digital intelligence",
    detail:
      "Providing comprehensive document digitization services to help you achieve standardized, digitized, data-driven, and intelligent document management.",
    contentList: [
      {
        tit: "Consulting services",
        imgUrl: require("../assets/images/solution/archives/industry4.png")
          .default,
        detail:
          "Provide professional document digitization consulting services, including demand analysis, program design, and implementation planning.",
        list: [
          "Demand Analysis",
          "Program Design",
          "Implementation Plan",
          "Technical support",
        ],
      },
      {
        tit: "Software services",
        imgUrl: require("../assets/images/solution/archives/industry5.png")
          .default,
        detail:
          "Provide document management system software, supporting customized development and system integration.",
        list: [
          "System Development",
          "Customized configuration",
          "System integration",
          "Technical support",
        ],
      },
      {
        tit: "Expand services",
        imgUrl: require("../assets/images/solution/archives/industry6.png")
          .default,
        detail:
          "Provide functional expansion and upgrade services for the document management system to meet business development needs.",
        list: [
          "Function expansion",
          "System upgrade",
          "Interface development",
          "Data migration",
        ],
      },
    ],
  },
  archives4: {
    til: "Why choose us?",
    contentList: [
      {
        tit: "Professional qualifications",
        imgUrl: require("../assets/images/solution/archives/carousel1.png")
          .default,
        detailList: ["Possessing multiple professional qualifications"],
      },
      {
        tit: "Technical strength",
        imgUrl: require("../assets/images/solution/archives/carousel2.png")
          .default,
        detailList: ["The technical team has an average of rich experience."],
      },
      {
        tit: "Project experience",
        imgUrl: require("../assets/images/solution/archives/carousel3.png")
          .default,
        detailList: [
          "Successfully delivered over 1000+ document projects.",
          "Customer satisfaction 100%",
        ],
      },
      {
        tit: "Security and confidentiality",
        imgUrl: require("../assets/images/solution/archives/carousel4.png")
          .default,
        detailList: [
          "Strictly implement national confidentiality regulations.",
          "Establish a sound security and confidentiality system.",
        ],
      },
      {
        tit: "Full-service",
        imgUrl: require("../assets/images/solution/archives/carousel5.png")
          .default,
        detailList: ["Provide one-stop service."],
      },
      {
        tit: "Professional qualifications",
        imgUrl: require("../assets/images/solution/archives/carousel1.png")
          .default,
        detailList: ["Possessing multiple professional qualifications"],
      },
      {
        tit: "Technical strength",
        imgUrl: require("../assets/images/solution/archives/carousel2.png")
          .default,
        detailList: ["The technical team has an average of rich experience."],
      },
      {
        tit: "Project experience",
        imgUrl: require("../assets/images/solution/archives/carousel3.png")
          .default,
        detailList: [
          "Successfully delivered over 1000+ document projects.",
          "Customer satisfaction 100%",
        ],
      },
      {
        tit: "Security and confidentiality",
        imgUrl: require("../assets/images/solution/archives/carousel4.png")
          .default,
        detailList: [
          "Strictly implement national confidentiality regulations.",
          "Establish a sound security and confidentiality system.",
        ],
      },
      {
        tit: "Full-service",
        imgUrl: require("../assets/images/solution/archives/carousel5.png")
          .default,
        detailList: ["Provide one-stop service."],
      },
    ],
  },
  archives5: {
    til: "Enable different industries to find more suitable collaborative methods for themselves.",
    case1: "View Case",
    case2: "Customer Case",
    case1Url: require("../assets/images/solution/archives/case.png")
            .default,
  },
};
const spaceOperations = {
  space_part2: {
    title: "Are your space operations facing these challenges",
    spact_partList: [
      {
        itemTitle: "Heavy construction, light operation",
        itemContent: "Lack of overall planning and fragmented system",
      },
      {
        itemTitle: "Data silo",
        itemContent:
          "The systems of transportation, security, and energy consumption are isolated from each other, resulting in low collaborative efficiency",
      },
      {
        itemTitle: "High management costs",
        itemContent:
          "Relying on a large amount of manual labor makes it difficult to control operating costs",
      },
      {
        itemTitle: "Lack of experience",
        itemContent:
          "Employees and visitors lack convenient, intelligent, and warm space experience",
      },
    ],
    dotColor: "#008AD4",
  },
  space_part3: {
    title: "Five core modules",
    subhead:
      " covering the needs of space operation and management, creating an intelligent and humanized enterprise space experience",
    space_part3List: [
      {
        itemTitle: "Space safety",
        itemContent:
          "Build an enterprise digital and intelligent passage and security solution that ensures smooth flow and security in every space and every corner.",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part1.png")
            .default,
        type: "first",
      },
      {
        itemTitle: "Space collaboration",
        itemContent:
          "Improve the utilization efficiency of enterprise space resources, and achieve intelligent reservation and efficient collaboration for resources such as meeting rooms and workstations",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part2.png")
            .default,
        type: "second",
      },
      {
        itemTitle: "Space communication",
        itemContent:
          "Build an internal information dissemination and communication platform within the enterprise to achieve precise information delivery and efficient information flow.",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part3.png")
            .default,
        type: "third",
      },
      {
        itemTitle: "Space communication",
        itemContent:
          "Build an enterprise brand image exhibition and cultural dissemination system to enhance brand value and cultural identity",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part4.png")
            .default,
        type: "fourth",
      },
      {
        itemTitle: "Space twin",
        itemContent:
          "Create a digital mirror of the physical space, achieving comprehensive digital management and visualized operation of all spatial elements",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part5.png")
            .default,
        type: "fifth",
      },
    ],
    learn_more: "Learn more",
  },
  space_part4: {
    title: "Three reasons to choose Huilian Space for operation",
    spact_partList: [
      {
        itemTitle: "integrated platform",
        itemContent:
          "Breaking system silos, one platform covers all scenarios, reducing integration and operation complexity",
      },
      {
        itemTitle: "Ultimate user experience",
        itemContent:
          "Introducing best practices such as ITIL, standardizing service processes, and ensuring delivery quality",
      },
      {
        itemTitle: "Data driven value",
        itemContent:
          "Deeply analyze operational data to assist in energy conservation, consumption reduction, quality improvement, and efficiency enhancement, achieving refined and lean management",
      },
    ],
    dotColor: "rgba(0, 138, 212, 0.12)",
  },
  space_part5: {
    title: "Multiple application scenarios",
    subhead:
      "Digitized solutions empower various spaces to achieve efficient operational management",
    space_partList: [
      {
        itemTitle: "Office space",
        itemContent:
          "Improve the comfort and efficiency of the office environment, and create an intelligent and efficient modern office experience",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part6.png")
            .default,
      },
      {
        itemTitle: "Commercial complex",
        itemContent:
          "Optimize flow guidance and merchant layout to enhance customer experience and commercial value",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part7.png")
            .default,
      },
      {
        itemTitle: "Industrial park",
        itemContent:
          "Integrate park resources, achieve cross enterprise collaboration, and improve overall operational efficiency of the park",
        imgUrl:
          require("../assets/images/solution/spaceOperations/space_part8.png")
            .default,
      },
    ],
  },
  KernelModule: {
    nav: {
      title: "Solution Navigation",
      titleIcon: require("../assets/images/solution/kernelModulePage/icon3.png")
        .default,
      list: [
        {
          label: "Space safety",
          value: "first",
        },
        {
          label: "Space collaboration",
          value: "second",
        },
        {
          label: "Space communication",
          value: "third",
        },
        {
          label: "Space propagation",
          value: "fourth",
        },
        {
          label: "Space twin",
          value: "fifth",
        },
      ],
      footer: "Contact us for program details",
      onLine: "Try it now",
    },
    first: {
      introduce:
        'Build a digital image of physical space to achieve digital management and visual operation of all spatial elements. As the "digital base" and "smart brain" of all solutions, the Space Twin Platform connects all elements of space, including people, things, objects, and fields, providing enterprises with a one-stop digital solution for space operation and management.',
      imgUrl: require("../assets/images/solution/kernelModulePage/first.png")
        .default,
      list_one: [
        {
          title: "Smart Traffic",
          content:
            "Facial recognition, one code access, vehicle management, to achieve a seamless, efficient, and orderly travel experience.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "Smart Visitor",
          content:
            "Online reservation, self-service terminal, and permission linkage enhance visitor experience and security efficiency.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "Safety Alert",
          content:
            "Electronic fence, video AI analysis, intelligent patrol, achieve proactive security prevention.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
      ],
      list_two: [
        "Enhance security level: Multiple intelligent security measures to achieve comprehensive security protection",
        "Reduce security labor costs: Intelligent management reduces manual intervention and optimizes human resource allocation",
        "Improving traffic efficiency and experience: seamless traffic, reducing waiting time, and enhancing employee satisfaction",
        "Data based management decision-making: statistical analysis of traffic data to provide data support for management optimization",
      ],
      list_three: [
        {
          title: "Main entrance of the park",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "Building lobby",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "Important channel",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "Office access control",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
      ],
      list_four: [
        "Intelligent facial recognition gate",
        "Self service visitor terminal",
        "Intelligent access control panel",
      ],
    },
    second: {
      introduce:
        "Improve the efficiency of enterprise space resource utilization, achieve intelligent reservation and efficient collaboration of conference rooms, workstations and other resources. Optimizing spatial resource allocation through digital means, improving space utilization, reducing operating costs, and creating a more flexible and efficient working environment for employees.",
      imgUrl: require("../assets/images/solution/kernelModulePage/second.png")
        .default,
      list_one: [
        {
          title: "Smart Space Reservation",
          content:
            "Online query, reservation, and management of space resources such as conference rooms, workstations, and negotiation areas, supporting multi terminal synchronization.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "Intelligent environmental regulation",
          content:
            "Intelligent linkage and remote control of environmental equipment such as temperature, humidity, lighting, and air conditioning to create a comfortable office environment.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "Spatial data analysis",
          content:
            "Statistical analysis of data such as space utilization rate, reservation rate, and satisfaction provides decision support for space optimization.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
      ],
      list_two: [
        "Improve space utilization: Intelligent reservation system reduces resource idle and enhances space utilization efficiency",
        "Reduce operating costs: optimize space allocation, reduce ineffective space occupation, lower rental and maintenance costs",
        "Improving work efficiency: Convenient space reservation and environmental control, reducing administrative transaction time costs",
        "Optimizing Office Experience: Comfortable Environment and Flexible Space Selection to Enhance Employee Satisfaction and Creativity",
      ],
      list_three: [
        {
          title: "meeting room",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "Open workstations",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "negotiation area",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "leisure space",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
      ],
      list_four: [
        "Smart conference room reservation screen",
        "Environmental Control Panel",
        "Spatial data analysis platform",
      ],
    },
    third: {
      introduce:
        "Build an internal information release and communication platform for enterprises to achieve precise information dissemination and efficient circulation. Through multi terminal collaboration and intelligent push, important information is ensured to be transmitted in a timely manner, promoting efficient communication and collaboration within the organization.",
      imgUrl: require("../assets/images/solution/kernelModulePage/third.jpg")
        .default,
      list_one: [
        {
          title: "Intelligent Information Release",
          content:
            "Accurate release and push of enterprise announcements, notifications, events, and other information, supporting synchronous display on multiple terminals.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "Instant messaging integration",
          content:
            "Seamless integration with enterprise IM system, supporting message push, quick reply, and group chat functions, promoting team communication.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "Intelligent Q&A Assistant",
          content:
            "An AI driven intelligent question answering system that answers common employee questions and provides self-service support.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
      ],
      list_two: [
        "Improve information transmission efficiency: ensure timely and accurate transmission of important information to the target audience",
        "Reduce communication costs: Reduce traditional communication methods such as meetings and emails to improve communication efficiency",
        "Enhance organizational collaboration: break down departmental barriers, promote cross departmental information sharing and collaboration",
        "Enhancing employee satisfaction: Convenient information acquisition and communication methods to improve employee experience",
      ],
      list_three: [
        {
          title: "Corporate Announcement",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "Departmental Notice",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "Employee Q&A",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "team collaboration",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
      ],
      list_four: [
        "Information publishing terminal",
        "Intelligent Q&A terminal",
        "Communication management platform",
      ],
    },
    fourth: {
      introduce:
        "Build a corporate brand image display and cultural communication system to enhance brand value and cultural identity. Through digital media networks and intelligent content management, precise dissemination of brand information and effective penetration of corporate culture can be achieved.",
      imgUrl: require("../assets/images/solution/kernelModulePage/fourth.jpg")
        .default,
      list_one: [
        {
          title: "Digital signage network",
          content:
            "The digital signage network for both internal and external spaces of the enterprise supports the display of multimedia content such as high-definition videos, images, and text.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "Content Management System",
          content:
            "A centralized content creation, review, and publishing platform that supports remote updates and precise delivery, ensuring the timeliness of content.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "Analysis of Communication Effectiveness",
          content:
            "Statistical analysis of content browsing volume, dwell time, interaction rate, and other data to evaluate dissemination effectiveness and optimization strategies.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
      ],
      list_two: [
        "Enhance brand image: Unified and professional visual image display to enhance brand awareness",
        "Strengthening cultural identity: Visual dissemination of corporate culture to enhance employees' sense of belonging and identification",
        "Improve information reach: Diversified display terminals and precise delivery ensure effective information reach",
        "Reduce communication costs: Digital content management and publishing, reducing printing materials and labor costs",
      ],
      list_three: [
        {
          title: "Lobby Display",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "Elevator lobby",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "Meeting room",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "Office area",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
      ],
      list_four: [
        "High definition digital signage",
        "Transparent display screen",
        "Content management platform",
      ],
    },
    fifth: {
      introduce: `Build a digital image of physical space to achieve digital management and visual operation of all spatial elements. As the "digital base" and "smart brain" of all solutions, the Space Twin Platform connects all elements of space, including people, things, objects, and fields, providing enterprises with a one-stop digital solution for space operation and management.`,
      imgUrl: require("../assets/images/solution/kernelModulePage/fifth.jpg")
        .default,
      list_one: [
        {
          title: "3D space modeling",
          content:
            "High precision physical space 3D modeling, restoring real spatial layout and details, and constructing digital twins.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "Real time data synchronization",
          content:
            "Real time data collection and synchronization of space equipment, environment, personnel, etc., to achieve the linkage between physical space and digital space.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "Data visualization analysis",
          content:
            "Multi dimensional data visualization display and in-depth analysis, supporting real-time monitoring of spatial operation status and decision support.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
        {
          title: "Intelligent Decision Support",
          content:
            "AI driven spatial operation optimization suggestions and intelligent decision support to achieve refinement and lean spatial management.",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon1.png")
              .default,
        },
      ],
      list_two: [
        "One stop operation platform: integrating all space management functions, providing a unified operation interface, and reducing management complexity",
        "Full lifecycle management: covering the entire process of spatial planning, construction, operation, and optimization, achieving closed-loop management",
        "Data visualization: intuitive display of complex spatial data, improving management efficiency and decision-making accuracy",
        `Comprehensively analyze spatial usage behavior and cost data, optimize resource allocation and cost control`,
      ],
      list_three: [
        {
          title: "Park Management",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "Building Operations",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "office space",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
        {
          title: "Smart Exhibition Hall",
          iconUrl:
            require("../assets/images/solution/kernelModulePage/icon2.png")
              .default,
        },
      ],
      list_four: [
        "Twin Modeling Engine",
        "Data Integration Platform",
        "Visual Decision Center",
      ],
    },
  },
};

const solution_infoServices = {
  infoServices1: {
    til: "Archive Enjoy® · Full-cycle Management of Archive Digital Transformation",
    dil: "From standard establishment to compliant destruction, covering the entire lifecycle of document management, providing safe, efficient, and intelligent solutions for document digitization.",
    imgUrl: require("../assets/images/solution/infoServices/customized.png")
      .default,
    width: "900px", //图片宽度
  },
  infoServices2: {
    til: "Dangdangxiang® · Enjoy the future brought by data archives",
    dil: "",
    contractList: [
      {
        title: "Full-process functional coverage",
        detail: "Seamless connection between all links of archive management",
        list: [
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future1_1.png")
                .default,
            text: "Document review and value appraisal",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future1_2.png")
                .default,
            text: "Intelligent filing and component management",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future1_3.png")
                .default,
            text: "Case file reference table storage and archiving",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future1_4.png")
                .default,
            text: "Archives shelving and location management",
          },
        ],
      },
      {
        title: "Comprehensive security permission guarantee",
        detail: "Fully guarantee the security of archival information",
        list: [
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future2_1.png")
                .default,
            text: "Three-person separation of authority management",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future2_2.png")
                .default,
            text: "Four-character detection",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future2_3.png")
                .default,
            text: "Integrated National Cryptographic Algorithms and Digital Watermarking Technology",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future2_4.png")
                .default,
            text: "Full record of operation logs and audit trail",
          },
        ],
      },
      {
        title: "Future knowledge system",
        detail:
          "Intelligent technology drives innovation in archive management",
        list: [
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future3_1.png")
                .default,
            text: "Distributed data analysis engine",
            detail: "Fast retrieval speed and wide scale",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future3_2.png")
                .default,
            text: "Analysis and recognition of domestic large models",
            detail: "Fill the gap in unstructured data retrieval",
          },
          {
            imgUrl:
              require("../assets/images/solution/infoServices/future3_3.png")
                .default,
            text: "low-code platform",
            detail: "Drag-and-drop components enable rapid configuration",
          },
        ],
      },
    ],
  },
  infoServices3: {
    til: "Dangdangxiang® · Core Content",
    dil: "Six product systems, covering all aspects of archive management needs, providing complete solutions",
    jumpText: "Try it now",
    learnMore: "Learn More",
    contractList: [
      {
        label: "data collection",
        title: "Digital archival acquisition system",
        text: "Multi-source data collection and digital processing",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate1.png")
            .default,
        list: [
          "Automatic recognition and collection of multi-format files",
          "High-speed scanning and OCR recognition of paper archives",
          "Intelligent extraction and cataloging of metadata",
          "Batch processing and quality review",
        ],
      },
      {
        label: "core platform",
        title: "Digital archive management system",
        text: "Core archive management platform, enabling full lifecycle management of archives",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate2.png")
            .default,
        list: [
          "Comply with national archives management standards and norms",
          "Integrated management of electronic and physical archives",
          "Standardized business processing throughout the entire process",
          "Intelligent retrieval and quick location",
        ],
      },
      {
        label: "Entity management",
        title: "IOT warehouse management system",
        text: "Intelligent warehouse environment monitoring and physical archive management",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate3.png")
            .default,
        list: [
          "Real-time monitoring and early warning of temperature and humidity",
          "Archives location and intelligent shelving",
          "Security monitoring and abnormal alarm",
          "Equipment linkage and automation control",
        ],
      },
      {
        label: "Application Service",
        title: "Digital Archive Borrowing System",
        text: "Online borrowing and utilization management",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate4.png")
            .default,
        list: [
          "Intelligent retrieval and precise positioning",
          "Online borrowing application and approval process",
          "Online preview of electronic files",
          "Borrowing tracking and return reminder",
        ],
      },
      {
        label: "data analysis",
        title: "Archive digital analysis platform",
        text: "Archive Data Mining and Knowledge Discovery",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate5.png")
            .default,
        list: [
          "Multidimensional analysis of archival data",
          "Construction and Display of Knowledge Graph",
          "Intelligent discovery of hot issues",
          "Decision Support and Trend Prediction",
        ],
      },
      {
        label: "Advanced applications",
        title: "Archive Data Mining Platform",
        text: "Big data analysis and visualization display",
        imgUrl:
          require("../assets/images/solution/infoServices/collaborate6.png")
            .default,
        list: [
          "Massive archive data processing engine",
          "Custom reports and visual dashboards",
          "Data assetization and value evaluation",
          "Construction of Industry Knowledge Base",
        ],
      },
    ],
  },
  infoServices4: {
    til: "Focusing on providing professional solutions for different enterprises",
    dil: "Provide customized archive information solutions tailored to the characteristics and needs of different industries, addressing industry-specific pain points",
    title2: "Solution features",
    icon: require("../assets/images/solution/infoServices/carousel1.png")
      .default,
    icon2: require("../assets/images/solution/infoServices/icon2.png")
      .default,
    background: "#f0f9fd",
    contractList: [
      {
        title: "government agency",
        detail:
          "The number of archives is huge, the types are diverse, the confidentiality requirements are high, and the access is frequent",
        label:
          "Improve government efficiency, ensure information security, and achieve transparent government affairs",
        list: [
          "Hierarchical permission management and operation audit",
          "Cross departmental file sharing and collaboration platform",
          "Integration of electronic signature and document circulation",
          "Digitization and Long term Preservation of Historical Archives",
        ],
      },
      {
        title: "financial industry",
        detail:
          "The large number and diverse types of archives require extremely high confidentiality and timeliness, and compliance risks are prominent",
        label:
          "Ensure information security and compliance, enhance risk control capabilities and operational efficiency, and reduce management costs",
        list: [
          "Intelligent warehousing",
          "Automated Management",
          "Quick access",
          "secure storage",
        ],
      },
      {
        title: "education industry",
        detail:
          "Scattered student information, high demand for recording growth trajectories, and strict requirements for privacy protection",
        label:
          "Improve management efficiency and home school communication experience, protect student privacy, and provide data support for personalized teaching and scientific decision-making",
        list: [
          "Digital management of student files",
          "Permission grading (different access permissions)",
          "Integration of registration, scheduling, and attendance",
        ],
      },
      {
        title: "medical industry",
        detail:
          "Contains a large amount of patient privacy, high security requirements, and strong demand for precise retrieval",
        label:
          "Protecting patient privacy, improving diagnosis and treatment efficiency and safety, and providing support for clinical diagnosis and scientific research",
        list: [
          "Strict permission management",
          "Advanced encryption technology",
          "Accurate search function",
        ],
      },
      {
        title: "Judicial industry",
        detail:
          "The authentic records of lawyer business activities, important national professional archives, involving a large amount of sensitive information and secrets, require strict approval for access and retrieval",
        label:
          "Ensure the integrity and security of archives, provide services for legal practice, comply with regulations, and protect client confidentiality",
        list: [
          "Establish a standardized management system",
          "Strict borrowing and review approval",
          "Archive appraisal and destruction process",
          "Safety protection measures",
        ],
      },
      {
        title: "state-owned enterprise",
        detail:
          "Strict compliance with national archives management regulations and industry standards is required, with complex business processes and multi departmental collaboration. Massive historical archives need to be preserved and their value excavated",
        label:
          "Ensure compliance, improve process collaboration efficiency, explore the value of archival data to support decision-making, and inherit the history and culture of the enterprise",
        list: [
          "Compliance management",
          "Deep integration of business systems such as OA and ERP",
          "Data Analysis and Mining",
          "Digitization of historical archives",
        ],
      },
      {
        title: "Large equipment industry",
        detail:
          "Complex product structure, long lifecycle, multiple version iterations, high precision requirements, high quality traceability pressure, and complex supply chain collaboration",
        label:
          "Ensure the security of technical knowledge assets, improve the efficiency of design and manufacturing collaboration, achieve full lifecycle quality traceability, and reduce compliance and after-sales risks",
        list: [
          "Product Data Management/Product Lifecycle Management Integration",
          "Strict version control and change process traceability",
          "Authorization Management and Collaboration Platform for Outsourced Supply Chain Units",
          "Secure storage and efficient transmission of big data blocks (such as 3D models)",
          "Integrate with MES and QMS systems to achieve full lifecycle traceability",
        ],
      },
      {
        title: "Adaptive and customized exclusive services",
        detail:
          "Each project/client profile is unique, containing a large number of communication records, creative drafts, and design source files; The version is prone to confusion, and customer needs are constantly changing, requiring full traceability throughout the process; Complex cost and quotation management",
        label:
          "Protect intellectual property rights of creative design, avoid losses caused by version errors, clearly trace changes in customer requirements, improve customer experience and repurchase rate, and provide data reference for similar projects",
        list: [
          `Archive organization model centered around "customer projects"`,
          "Version management of design drafts/source code",
          "Customer communication records and requirement change traceability",
          "Cost accounting and quotation document association management",
          "Archiving of finished product photos and customer acceptance data",
        ],
      },
    ],
  },
  infoServices5: {
    name: "core technology",
    dil: "Integrating cutting-edge technology and innovative concepts to provide strong technical support for archive informatization",
    contractList: [
      {
        name: "One click search",
        imgUrl: require("../assets/images/solution/infoServices/advantage1.png")
          .default,
      },
      {
        name: "intelligent assistance",
        imgUrl: require("../assets/images/solution/infoServices/advantage2.png")
          .default,
      },
      {
        name: "Document parsing",
        imgUrl: require("../assets/images/solution/infoServices/advantage3.png")
          .default,
      },
      {
        name: "data encryption",
        imgUrl: require("../assets/images/solution/infoServices/advantage4.png")
          .default,
      },
    ],
  },
  infoServices6: {
    til: "Strong technical strength ensures excellent product experience",
    dil: "Having a professional team consisting of AI algorithm experts, archive management experts, and software engineers, we continuously innovate and make technological breakthroughs to provide customers with stable, reliable, secure, and efficient archive information solutions",
    contractList: [
      {
        num: "50+",
        detail: "Technology patents and software copyrights",
      },
      {
        num: "100%",
        detail: "System stability guarantee",
      },
      {
        num: "500 thousand+",
        detail: "Daily average file processing capability",
      },
      {
        num: "24-hour-online",
        detail: "Professional technical support services",
      },
    ],
  },
};
const residency = {
  space_part2: {
    title: "Core services",
    list_one: [
      {
        iconUrl: require("../assets/images/solution/residency/part1.png")
          .default,
        iconUrl2:
          require("../assets/images/solution/residency/part1_active.png")
            .default,
        title: "Office Equipment Operation and Maintenance",
        id: 1,
      },
      {
        iconUrl: require("../assets/images/solution/residency/part2.png")
          .default,
        iconUrl2:
          require("../assets/images/solution/residency/part2_active.png")
            .default,
        title: "IT infrastructure on-site",
        id: 2,
      },
      {
        iconUrl: require("../assets/images/solution/residency/part3.png")
          .default,
        iconUrl2:
          require("../assets/images/solution/residency/part3_active.png")
            .default,
        title: "Software development and testing on-site",
        id: 3,
      },
    ],
    list_two: [
      {
        title: "Intelligent office equipment operation and maintenance",
        subhead:
          "Focusing on the maintenance and management of hardware devices, ensuring that your office equipment is always in optimal operating condition, reducing downtime due to malfunctions, and improving work efficiency.",
        imgUrl: require("../assets/images/solution/residency/part1_img.png")
          .default,
        list_two_list: [
          "Daily maintenance and troubleshooting of desktop and laptop computers",
          "Installation and debugging of office peripherals such as printers and copiers",
          "Regular inspection and preventive maintenance of office equipment",
          "Installation and configuration of device drivers and software",
        ],
        dot: require("../assets/images/solution/residency/yesicon.png").default,
      },
      {
        title: "IT infrastructure on-site",
        subhead:
          "Comprehensive services covering on-site IT engineers, desktop engineers, and network engineers ensure the stable and reliable operation of your IT infrastructure.",
        imgUrl: require("../assets/images/solution/residency/part2_img.png")
          .default,
        list_two_list: [
          "Resident IT Engineer: Daily maintenance of servers and storage devices",
          "Desktop Engineer: Terminal Devices and User Support Services",
          "Network Engineer: Network Device Configuration and Performance Optimization",
          "Implementation of Infrastructure Monitoring and Fault Warning System",
        ],
        dot: require("../assets/images/solution/residency/yesicon.png").default,
      },
      {
        title: "Software development and testing on-site",
        subhead:
          "Deploy professional development and testing engineers to seamlessly integrate into your team, provide high-quality software development and testing services, and accelerate product iteration and delivery.",
        imgUrl: require("../assets/images/solution/residency/part3_img.png")
          .default,
        list_two_list: [
          "Resident Development Engineer: Develop and maintain software projects based on requirements",
          "On site testing engineer: functional testing, performance testing, and compatibility testing",
          "Support multiple technology stacks: Java, frontend, PHP, etc",
          "Agile development process support enables quick response to changes in business requirements",
        ],
        dot: require("../assets/images/solution/residency/yesicon.png").default,
      },
    ],
  },
  space_part3: {
    title: "Our Advantages",
    list: [
      {
        itemTitle: "Talent Matrix",
        itemContent:
          "Having a comprehensive technical talent pool covering hardware, network, system, development, and testing, accurately matching project requirements.",
        iconUrl: require("../assets/images/solution/residency/part4.png")
          .default,
      },
      {
        itemTitle: "Process standards",
        itemContent:
          "Introducing best practices such as ITIL, standardizing service processes, and ensuring delivery quality.",
        iconUrl: require("../assets/images/solution/residency/part5.png")
          .default,
      },
      {
        itemTitle: "safety compliance",
        itemContent:
          "The on-site personnel sign a strict confidentiality agreement and operate in accordance with security regulations to safeguard your data security.",
        iconUrl: require("../assets/images/solution/residency/part6.png")
          .default,
      },
    ],
  },
  space_part4: {
    introduceTitle: "On-site service",
    introduceContent:
      "Professional on-site service, customized according to needs, dedicated personnel on duty, providing comprehensive technical support for your business",
    title: "service model",
    list: [
      {
        itemTitle: "On-demand customization",
        itemContent:
          "Based on your business needs and budget, flexibly customize on-site service plans to ensure optimal resource allocation.",
        iconUrl: require("../assets/images/solution/residency/part7.png")
          .default,
      },
      {
        itemTitle: "Dedicated personnel and positions",
        itemContent:
          "We match experienced professionals with a focus on specific job requirements and a deep understanding of business scenarios.",
        iconUrl: require("../assets/images/solution/residency/part8.png")
          .default,
      },
      {
        itemTitle: "Team entry",
        itemContent:
          "Provide a complete technical team on-site support, from project planning to implementation and landing, providing full support throughout the process.",
        iconUrl: require("../assets/images/solution/residency/part9.png")
          .default,
      },
    ],
    otherInfo: {
      title: "Flexible cooperation methods",
      content:
        "Whether it is short-term project support or long-term on-site services, we can provide flexible collaboration models that can be adjusted according to your business cycle and project needs, ensuring service quality while minimizing costs to the greatest extent possible.",
      btnText: "Contact Us",
    },
  },
  space_part5: {
    introduceTitle: "Resolve enterprise difficulties",
    introduceContent:
      "Professional IT on-site services effectively solve talent management problems for enterprises, reduce costs and risks",
    first: {
      title:
        'The "three difficulties and two highs" challenges faced by enterprises',
      describe:
        "In the process of IT talent management, enterprises generally face difficulties in recruiting, cultivating, and retaining talents, as well as challenges of high costs and risks",
      list: [
        {
          itemTitle: "Difficulty recruiting",
          itemContent:
            "The recruitment process is complicated, the evaluation criteria are strict, the competition pressure is high, and it is difficult to recruit outstanding talents",
        },
        {
          itemTitle: "Difficulty in educating people",
          itemContent:
            "The investment in cultivating talent resources is large, personalized training is difficult, and talent cultivation is challenging",
        },
        {
          itemTitle: "Difficulty in retaining people",
          itemContent:
            "The promotion channel is relatively narrow, and I feel confused about my career prospects, making it difficult to clearly outline my future development direction",
        },
        {
          itemTitle: "High risk",
          itemContent:
            "Personnel optimization can easily lead to disputes, strict laws and regulations make it difficult to prevent and control employment risks ",
        },
        {
          itemTitle: "High cost",
          itemContent:
            "The salary and welfare system is complex, the burden of social security is heavy, and labor costs remain high",
        },
      ],
    },
    second: {
      title: "Comprehensive implementation strategy",
      describe:
        "We provide systematic solutions to address the talent management challenges faced by enterprises, helping them overcome difficulties      ",
      list: [
        {
          itemTitle: "Talent recruitment and screening",
          list: [
            "Expand diversified recruitment channels",
            "Precision talent screening strategy",
          ],
        },
        {
          itemTitle: "Talent cultivation and development",
          list: ["Systematic training system", "Talent Enhancement Plan"],
        },
        {
          itemTitle: "Talent retention and motivation",
          list: [
            "Improve career development channels",
            "Positive and uplifting corporate culture",
          ],
        },
        {
          itemTitle: "Risk control",
          list: [
            "Legal risk control",
            "Data security control",
            "Risk response in talent management",
          ],
        },
        {
          itemTitle: "Cost control",
          list: [
            "Cost control in personnel management stage",
            "Cost control during project execution phase",
          ],
        },
      ],
    },
  },
  space_part6: {
    introduceTitle: "Talent team",
    introduceContent:
      "A professional technical team is the core guarantee for us to provide high-quality services",
    title: "Talent Philosophy",
    describe: `Not only providing people, but also providing qualified, stable, and efficient technical partners. We select talents through a strict screening process, continuously improve our abilities through a training system, and ensure service quality through a scientific management system.`,
    list: [
      {
        itemTitle: "Strict screening",
        itemContent:
          "Multiple rounds of technical interviews and comprehensive ability assessments ensure that candidates possess solid professional skills and good professional ethics.",
        iconUrl: require("../assets/images/solution/residency/part10.png")
          .default,
      },
      {
        itemTitle: "Continuous training",
        itemContent:
          "Regularly organize technical sharing and skill training to help engineers maintain technological leadership and enhance their ability to solve complex problems.",
        iconUrl: require("../assets/images/solution/residency/part11.png")
          .default,
      },
      {
        itemTitle: "Performance management",
        itemContent:
          "Establish a scientific performance evaluation system to motivate engineers to provide better services and achieve mutual growth between individuals and enterprises.",
        iconUrl: require("../assets/images/solution/residency/part12.png")
          .default,
      },
    ],
  },
};
const solution_asset = {
  asset1: [
    {
      num: "500+",
      detail: "service enterprise",
    },
    {
      num: "200 thousand+",
      detail: "Manage assets",
    },
    {
      num: "50+",
      detail: "Coverage cities",
    },
    {
      num: "100%",
      detail: "customer satisfaction",
    },
  ],
  asset2: {
    title:
      "Comprehensive solution covering the entire asset management process",
    detail:
      "From equipment storage to disposal, from repair to evaluation, from data silos to global interconnectivity, all encompassing digital management",
    content: {
      title: "Asset lifecycle management",
      detail:
        "Systematic management should be carried out for the entire lifecycle of fixed assets, including the management of the entire process of fixed asset acquisition, registration, requisition, borrowing, allocation, inventory, maintenance, depreciation, disposal, etc.",
      imgUrl: require("../assets/images/solution/asset/lifeCycle.png").default,
      list: [
        {
          title: "Asset storage and file establishment",
          detail:
            "Register and file new assets, assign unique identification codes, and establish a digital foundation",
        },
        {
          title: "Daily operation and maintenance",
          detail:
            "Prevent malfunctions and extend asset lifespan through regular maintenance plans",
        },
        {
          title: "Maintenance Management",
          detail:
            "The online process from repair reporting to evaluation ensures rapid response and transparent handling of faults",
        },
        {
          title: "Change and Inventory Management",
          detail:
            "Manage the transfer and borrowing of assets, and conduct regular inventory checks to ensure that the accounts match the actual situation",
        },
        {
          title: "Scrap and retirement",
          detail:
            "Standardize the asset scrapping process, complete technical appraisal, approval, and financial write off",
        },
      ],
    },
  },
  asset3: {
    til: "Technical Architecture",
    dil: "Built on advanced technology stack to ensure system stability, security, efficiency, and safety",
    imgUrl: require("../assets/images/solution/asset/customized0.png").default,
    width: "900px",
  },
  asset4: {
    title: "Are your company's asset operations facing these challenges?",
    detail: "Industry background and challenges",
    contentList: [
      {
        til: "Difficulty in clearing assets",
        list: [
          "Missing ledger: scattered original records, untraceable asset circulation trajectory",
          "Process missing: Standard management process not established, asset data",
        ],
      },
      {
        til: "Asset activation dilemma",
        list: [
          "Asset pooling: discrepancies between accounts and reality, unreasonable allocation",
          `Application coordination: Difficult to meet departmental requirements, and sharing and reusing are challenging`,
        ],
      },
      {
        til: "Asset appreciation challenge",
        list: [
          "Low utilization rate: Idle assets are difficult to identify and adjust",
          "Shortened lifespan: Hidden loss, premature loss",
        ],
      },
    ],
  },
  asset5: {
    title: "Hui Lian Code Up Repair ™ ·  One stop solution for all problems",
    contentList: [
      {
        til: "Hui Lian Code Up Repair ™",
        til2: "Information management platform",
        detail:
          "Realize real-time dynamic collection of office equipment asset information, maintenance personnel information, and operation and maintenance service data, build a massive data resource library, and establish a complete office asset lifecycle management system.",
      },
      {
        til: "Hui Lian Code Up Repair ™",
        til2: "·  APP",
        detail:
          "A convenient application designed specifically for asset information management, providing efficient and intelligent mobile smart tools that support maintenance personnel's work order processing, asset information management, and repair request processing.",
      },
      {
        til: "Hui Lian Code Up Repair ™",
        til2: "·  mini program",
        detail:
          "Users can quickly submit a repair request, fill in a fault description, and upload photos by scanning the device's exclusive QR code or manually entering the device number. After the repair is completed, the service can be evaluated.",
      },
    ],
  },
  asset6: {
    title: "“Hui Lian Code Up Repair”™ ·  Intelligent repair management system",
    content1: {
      title1: "Equipment Management",
      title2: "Office Asset Management Platform",
      imgUrl: require("../assets/images/solution/asset/warrantyManagement1.png")
        .default,
      list: [
        {
          title: "Office asset management",
          detail:
            "The complete management process from procurement, warehousing, use, maintenance to scrapping",
        },
        {
          title: "Batch import and export",
          detail:
            "Support Excel batch import of device information and export of asset reports",
        },
        {
          title: "Generation and printing of repair code",
          detail:
            "Generate a unique repair QR code for each device, one click repair request",
        },
        {
          title: "Equipment Health Assessment",
          detail:
            "Automatically evaluate the health status of equipment based on historical data and provide early warning",
        },
      ],
    },
    content2: {
      title1: "Ticket Management",
      title2: "Full process management of work orders",
      imgUrl: require("../assets/images/solution/asset/warrantyManagement2.png")
        .default,
      imgUrl2: require("../assets/images/solution/asset/warrantyManagement2-2.png")
        .default,
      detail:
        "Work order management includes functions such as work order quantity statistics, creating new work orders, batch importing work orders, viewing work order details, and printing work order tables.",
      list: [
        "Create Ticket",
        "process ticket",
        "Assign work orders",
        "Complete work order",
      ],
    },
    content3: {
      title1: "Work point analysis",
      title2: "Work point calculation and performance evaluation",
      imgUrl: require("../assets/images/solution/asset/warrantyManagement3.png")
        .default,
      imgUrl2: require("../assets/images/solution/asset/warrantyManagement3-2.png")
        .default,
      list: [
        {
          tit: "Calculation rules for work points",
          detList: [
            "Basic work score: set according to the type and difficulty of the work order",
            "Timeliness reward: Additional bonus points for early completion",
            "Satisfaction Reward: Additional Points for Excellent Customer Reviews",
            "Complex task reward: additional bonus points for solving complex problems",
          ],
        },
        {
          tit: "Performance incentive system",
          detList: [
            "Monthly Work Score Ranking Reward",
            "Quarterly Excellent Engineer Selection",
            "Annual Service Star Commendation",
            "Skills Enhancement Training Opportunities",
          ],
        },
      ],
    },
    content4: {
      title1: "Mobile APP",
      title2: "Features of Mobile App Functions",
      imgUrl: require("../assets/images/solution/asset/warrantyManagement4.png")
        .default,
      list: [
        {
          title: "Real time receipt and processing of work orders",
          detail:
            "Engineers can receive work orders anytime, anywhere, and update processing status in real-time",
        },
        {
          title: "Equipment information query",
          detail:
            "Quickly query device details, historical maintenance records, and warranty information",
        },
        {
          title: "Scan the code to report for repair",
          detail:
            "Scan the device repair code and initiate a repair request with just one click",
        },
        {
          title: "Performance inquiry",
          detail:
            "Engineers can check their work scores and performance rankings at any time",
        },
        {
          title: "knowledge base",
          detail: "Built in solutions to common problems and repair guides",
        },
      ],
    },
    titList: [
      "Equipment Management",
      "Ticket Management",
      "Work point analysis",
      "Mobile APP",
    ],
  },
  asset7: {
    title: "Technical qualification protection",
    detail: "Professional certification, trustworthy",
    tabsName: "Professional Certification",
    iconUrl: require("../assets/images/solution/asset/iconurl.png").default,
    contentList: [
      "Certification for high-tech enterprises and specialized and innovative enterprises",
      "Certified by Information Security Management System",
      " Has 43 software copyright registrations",
      "Having been deeply involved in the industry for over 20 years, possessing a high level of service expertise",
    ],
    pList: [
      "Having been deeply involved in the office equipment service industry for over 20 years, we have accumulated rich experience and professional knowledge, and can provide the highest quality asset management solutions for various enterprises.",
      "Our team is composed of industry experts, dedicated to helping enterprises reduce costs, improve efficiency, and achieve intelligent management of office assets through technological innovation and service optimization.",
    ],
    cardList: [
      {
        title: "50+",
        detail: "Software Copyright",
      },
      {
        title: "20+",
        detail: "Industry accumulation",
      },
    ],
  },
};
const successOperations = {
  title: "success cases",
  detail: [
    "Explore how we can create real value for customers in various industries",
    "Provide professional solutions to assist clients in achieving digital transformation",
  ],
  beforeContent: {
    top: "Welcome to the case display platform",
    bottom: [
      "Explore how we create real value for clients in various industries",
      "With professional solutions, we help clients achieve digital transformation",
    ],
    btn:"View cases"
  },
};
const aboutUs = {
  space_part1: {
    title: "Welcome to Shanghai Huilian Office Equipment Co., Ltd",
    detail:
      "One stop smart office solution provider, making office simpler, smarter, and more efficient",
    btnText: "Try it now",
  },
  space_part2: {
    title: "About Huilian",
    list: [
      {
        itemTitle: "Address",
        itemContent:
          "No. 542 Muxing, Leshan Village, Jinhui Town, Fengxian District, Shanghai",
        iconUrl: require("../assets/images/aboutUs/icon1.png").default,
      },
      {
        itemTitle: "Email",
        itemContent: "huilian118@163.com",
        iconUrl: require("../assets/images/aboutUs/icon1.png").default,
      },
      {
        itemTitle: "Telephone",
        itemContent: "021-57186429",
        iconUrl: require("../assets/images/aboutUs/icon2.png").default,
      },
      {
        itemTitle: "Business Hours",
        itemContent: "Monday to Friday: 9:00 - 18:00",
        iconUrl: require("../assets/images/aboutUs/icon3.png").default,
      },
    ],
    describeTitle: "Visit us",
    describeContent:
      "Welcome to visit our company and achieve a win-win situation",
    learnMore: "Learn more",
    imgUrl: require("../assets/images/aboutUs/img.png").default,
  },
};

const onlineExperience = {
  title: "Online Experience",
  con1: "Company Name",
  con1Reminder: "Please fill in the company name",
  con2: "Industry Type",
  con3: "Contact Person Name",
  con3Reminder: "Please fill in the name of the contact person",
  con4: "Contact phone number",
  con4Reminder: "Please fill in the contact person's phone number",
  con4Reminder1: "Please enter the correct phone number",
  con5: "City",
  sub: "Submit an application",
};
export default {
  home,
  productList,
  navigation,
  solution_archives,
  spaceOperations,
  solution_infoServices,
  residency,
  solution_asset,
  successOperations,
  aboutUs,
  onlineExperience,
};
